/* This was developed to support the HistoryCreatePage */
import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import {
   Container,
   Grid,
   Paper,
   TextField,
   Typography
}                                               from '@material-ui/core'
import {
   CLIENT_PUBLIC_TOKEN
}                                               from '../config'
import { node_server }                          from '../Helpers'
import PropTypes                                from 'prop-types'

const GuestBioSearchComponent = ({ handleClick }) => {

   const [ searchTitleFor,    setSearchTitleFor       ]  =  useState('')
   const [ titleObjects,      setTitleObjects         ]  =  useState([])

   useEffect( () => {
      fetchData()
      async function fetchData() {
         axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
         axios.get( node_server + 'guestBio/getTitles' )
         .then( res => res.data )
         .then( data => {
            setTitleObjects(data)
         })
         .catch( (error) => {
            console.error(error)
         })
      }
   }, [] )

   const titlesToDisplay = titleObjects.map( t => {
      return (
         <Grid key={t._id} >
            <Typography align='left' style={{marginLeft: '1rem'}} onClick={() => handleClick(t)}>
               { t.title }
            </Typography>
         </Grid>
      )
   })

   const searchTitles = (e) => {
      setSearchTitleFor(e.target.value)
   }

   return (
      <Container>
         <Grid container style={{marginBottom: '1rem', width: '100%'}} >
            <Grid container item xs={12} style={{ alignItems: 'flex-start', width: '25%', marginBottom: '1rem' }} >
               <TextField
                  label='Search Titles For:'
                  name='search-photo-tags-input'
                  onChange={searchTitles}
                  style={{width: '430px'}}
                  variant='outlined'
               />
            </Grid>
            <Grid style={{ width: '70%' }} >
               <Paper className='photoTags' style={{ backgroundColor: "rgba(0, 0, 255, 0.05)" }} >
                  <Grid>
                     { titlesToDisplay }
                  </Grid>
               </Paper>
            </Grid>
         </Grid>
      </Container>
   )
}

GuestBioSearchComponent.propTypes = {
   handleClick:                                 PropTypes.func
}

export default GuestBioSearchComponent
